let defaultHeaderOptions = {};
if(typeof connectspace_config != "undefined") {
  defaultHeaderOptions = {
    "Content-Type": "application/json",
    "X-Notefit-Account-Api-Auth-Token": connectspace_config.api_auth_token
  };
  if(connectspace_config.team_api_auth_token) {
    defaultHeaderOptions["CS-Team-Api-Auth-Token"] = connectspace_config.team_api_auth_token;
  }
  if(connectspace_config.order_token) {
    defaultHeaderOptions["X-Notefit-Order-Token"] = connectspace_config.order_token;
  }
} else if(typeof notefit_config != "undefined") {
  defaultHeaderOptions = {
    "Content-Type": "application/json",
    "X-Notefit-Planner-Api-Auth-Token": notefit_config.api_auth_token,
    "X-Notefit-Team-Api-Auth-Token": notefit_config.team_api_auth_token
  };
} else {
  defaultHeaderOptions = {
    "Content-Type": "application/json"
  };
}


export default defaultHeaderOptions;
